import { render, staticRenderFns } from "./LogoCompany.vue?vue&type=template&id=61434133&scoped=true&"
import script from "./LogoCompany.vue?vue&type=script&lang=ts&"
export * from "./LogoCompany.vue?vue&type=script&lang=ts&"
import style0 from "./LogoCompany.vue?vue&type=style&index=0&id=61434133&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61434133",
  null
  
)

export default component.exports